import { gql } from '@apollo/client';

export const GET_TRIP_FEES = gql`
  query GetTripFees($userId: String!) {
    tripFees(userId: $userId) {
      id
      name
      chargeBy
      amount
      description
      userId
      createdAt
      updatedAt
      isActive
      uniqName
      rule
    }
  }
`;

export const GET_TRIP_FEE = gql`
  query GetTripFee($id: String!) {
    tripFee(id: $id) {
      id
      name
      chargeBy
      amount
      description
      userId
      createdAt
      updatedAt
      isActive
      uniqName
      rule
    }
  }
`;

export const CREATE_TRIP_FEE = gql`
  mutation CreateTripFee($input: CreateTripFeeInput!) {
    createTripFee(input: $input) {
      id
      name
      chargeBy
      amount
      description
      userId
      uniqName
      isActive
      createdAt
      updatedAt
      rule
    }
  }
`;

export const UPDATE_TRIP_FEE = gql`
  mutation UpdateTripFee($input: UpdateTripFeeInput!) {
    updateTripFee(input: $input) {
      id
      name
      chargeBy
      amount
      description
      userId
      isActive
      uniqName
      createdAt
      updatedAt
      rule
    }
  }
`;
